"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stackedChartColors = exports.lineChartColors = exports.cranberry = exports.emerald = exports.lavenderRose = exports.havelockBlue = exports.geraldine = exports.portGore = exports.casablanca = exports.brightTurquoise = exports.exportingConfig = exports.baseExportingConfig = exports.langConfigCs = exports.chartTitleStyleNew = exports.chartTitleStyle = exports.dataLablesLineChartFontStyle = exports.dataLablesStackedChartFontStyle = exports.chartHeight = exports.axisTitleChartFontStyle = exports.chartLegend = exports.axisChartLabelFontStyle = exports.chartFonts = void 0;
exports.chartFonts = "'Montserrat', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji'";
exports.axisChartLabelFontStyle = {
    color: '#666',
    fontWeight: '500',
    fontSize: '11px',
    fontFamily: exports.chartFonts,
};
exports.chartLegend = {
    align: 'center',
    verticalAlign: 'bottom',
    borderWidth: 0,
};
exports.axisTitleChartFontStyle = {
    color: '#333',
    fontWeight: '600',
    fontSize: '12px',
    fontFamily: exports.chartFonts,
};
exports.chartHeight = 860;
exports.dataLablesStackedChartFontStyle = {
    color: '#000',
    fontWeight: '700',
    fontSize: '11px',
    fontFamily: exports.chartFonts,
};
exports.dataLablesLineChartFontStyle = {
    textOutline: '#fff',
    color: '#000',
    fontWeight: '600',
    fontSize: '11px',
    fontFamily: exports.chartFonts,
};
exports.chartTitleStyle = {
    color: '#5150a9',
    fontWeight: '600',
    fontSize: '20px',
    fontFamily: exports.chartFonts,
};
exports.chartTitleStyleNew = {
    color: '#5150a9',
    padding: '0 0 0 0',
    fontWeight: '700',
    fontSize: '24px',
    lineHeight: '32px',
    letterSpacing: '0.2px',
    fontFamily: "'Montserrat', 'system-ui', '-apple-system', 'Segoe UI', 'Roboto', 'Helvetica', 'Arial', 'sans-serif', 'Apple Color Emoji', 'Segoe UI Emoji'",
};
exports.langConfigCs = {
    downloadJPEG: 'Stáhnout jako JPG',
    downloadPNG: 'Stáhnout jako PNG',
    downloadPDF: 'Stáhnout jako PDF',
    downloadCSV: 'Stáhnout jako CSV',
    downloadXLS: 'Stáhnout jako XLS',
    download: 'Stáhnout',
};
exports.baseExportingConfig = {
    enabled: true,
    filename: 'lp-distribuce',
    sourceHeight: 900,
    sourceWidth: 1400,
    width: 1400,
    buttons: {
        contextButton: {
            enabled: false,
        },
        exportButton: {
            text: exports.langConfigCs.download,
            theme: {
                fill: '#262955',
                stroke: '#262955',
                states: {
                    hover: {
                        fill: '#000000',
                        stroke: '#000000',
                    },
                    select: {
                        fill: '#000000',
                        stroke: '#000000',
                    },
                },
            },
            menuItems: [
                'exportButton',
                'downloadPDF',
                'downloadPNG',
                'downloadJPEG',
                'separator',
                'downloadCSV',
                'downloadXLS',
            ],
        },
    },
    chartOptions: {
        title: {
            widthAdjust: -100,
        },
        legend: {
            width: 1200,
            itemWidth: 300,
        },
        chart: {
            spacing: [10, 10, 10, 10],
            events: {
                load: function () {
                    this.renderer
                        .image('data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iaXNvLTg4NTktMSI/Pgo8c3ZnIHZlcnNpb249IjEuMSIgaWQ9IkxheWVyXzEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHg9IjBweCIgeT0iMHB4IgogICAgIHdpZHRoPSIzMzEuNDM0cHgiIGhlaWdodD0iODUuMjc3cHgiIHZpZXdCb3g9IjAgMCAzMzEuNDM0IDg1LjI3NyIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMzMxLjQzNCA4NS4yNzc7IgogICAgIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8Zz4KICAgIDxwYXRoIHN0eWxlPSJmaWxsOiM4MzczZGI7IiBkPSJNMjk5LjA2NCwyMi4wNTdjLTE4LjE2NSwwLjA3Mi0zMS45NjUsMTMuNzg4LTMxLjk2MywzMS43NzEKICAgICAgICBjMC4wMDIsMTguMzA4LDEzLjYyNywzMS41MTgsMzIuNDM3LDMxLjQ1YzE4LjU2OC0wLjA2NywzMS45NTEtMTMuMjk5LDMxLjg5NS0zMS41MzVDMzMxLjM3OCwzNS41NCwzMTcuNTI5LDIxLjk4NCwyOTkuMDY0LDIyLjA1N3oKICAgICAgICAgTTI5OS4xODYsNzEuMzIyYy05LjczNi0wLjAxNy0xNi41MzktNy4zMDctMTYuNDYyLTE3LjY0YzAuMDc4LTEwLjM4Niw2Ljg4MS0xNy42NjgsMTYuNTA5LTE3LjY3CiAgICAgICAgYzkuODU1LTAuMDAyLDE2LjYxNCw3LjI5OCwxNi42LDE3LjkyOUMzMTUuODE5LDY0LjMzNywzMDkuMTExLDcxLjM0LDI5OS4xODYsNzEuMzIyeiIvPgogICAgPHBhdGggc3R5bGU9ImZpbGw6IzgzNzNkYjsiIGQ9Ik04Ni43ODEsMjIuMDU3Yy0xOC4xNjUsMC4wNzItMzEuOTY1LDEzLjc4OC0zMS45NjMsMzEuNzcxYzAuMDAyLDE4LjMwOCwxMy42MjcsMzEuNTE4LDMyLjQzNywzMS40NQogICAgICAgIGMxOC41NjgtMC4wNjcsMzEuOTUxLTEzLjI5OSwzMS44OTUtMzEuNTM1QzExOS4wOTUsMzUuNTQsMTA1LjI0NiwyMS45ODQsODYuNzgxLDIyLjA1N3ogTTg2LjkwMyw3MS4zMjIKICAgICAgICBjLTkuNzM2LTAuMDE3LTE2LjUzOS03LjMwNy0xNi40NjItMTcuNjRjMC4wNzgtMTAuMzg2LDYuODgxLTE3LjY2OCwxNi41MDktMTcuNjdjOS44NTUtMC4wMDIsMTYuNjE0LDcuMjk4LDE2LjYsMTcuOTI5CiAgICAgICAgQzEwMy41MzYsNjQuMzM3LDk2LjgyOSw3MS4zNCw4Ni45MDMsNzEuMzIyeiIvPgogICAgPHBhdGggc3R5bGU9ImZpbGw6IzgzNzNkYjsiIGQ9Ik02MS4yNDYsNTMuNzY2aC0wLjAwM2MwLTAuMDMzLDAuMDAzLTAuMDY2LDAuMDAzLTAuMVY1My43NjZ6Ii8+CiAgICA8cGF0aCBzdHlsZT0iZmlsbDojODM3M2RiOyIgZD0iTTI0Ni44LDgzLjYxNGM1LjEzNSwwLDkuOTczLDAsMTUsMGMwLTE5Ljk3LDAtMzkuNzQ4LDAtNTkuODI1Yy01LjE5LDAtMTAuMTA3LDAtMTUsMAogICAgICAgIEMyNDYuOCw0My44MTUsMjQ2LjgsNjMuNjM4LDI0Ni44LDgzLjYxNHoiLz4KICAgIDxwYXRoIHN0eWxlPSJmaWxsOiM4MzczZGI7IiBkPSJNNDQuMDIsNDEuMTE3bDkuODctOS44N0M0MS41NCwxOC45NzQsMjEuNTc5LDE4Ljk5NSw5LjI1OCwzMS4zMTYKICAgICAgICBjLTEyLjM0NSwxMi4zNDUtMTIuMzQ1LDMyLjM1OSwwLDQ0LjcwNEMyMS41NzksODguMzQxLDQxLjU0LDg4LjM2Miw1My44OSw3Ni4wODlsLTkuODctOS44N2MtNi45LDYuODIzLTE4LjAyMyw2LjgwNC0yNC44OTQtMC4wNjcKICAgICAgICBjLTYuODk1LTYuODk1LTYuODk1LTE4LjA3MywwLTI0Ljk2OEMyNS45OTcsMzQuMzEzLDM3LjEyLDM0LjI5Myw0NC4wMiw0MS4xMTd6Ii8+CiAgICA8cGF0aCBzdHlsZT0iZmlsbDojODM3M2RiOyIgZD0iTTYxLjI0Niw1My43NjZ2LTAuMWMwLDAuMDMzLTAuMDAzLDAuMDY2LTAuMDAzLDAuMUg2MS4yNDZ6Ii8+CiAgICA8cGF0aCBzdHlsZT0iZmlsbDojODM3M2RiOyIgZD0iTTI5LjUzNiwyMi4wNTZ2MC4wMDNjMC4wMzMsMCwwLjA2Ni0wLjAwMywwLjEtMC4wMDNIMjkuNTM2eiIvPgogICAgPHBhdGggc3R5bGU9ImZpbGw6IzgzNzNkYjsiIGQ9Ik0yMjguNjk2LDIzLjc4OWwtMTQuNDg1LDM5LjUyM2wtMTQuNDg1LTM5LjUyM2gtMTYuNDE4bDIxLjkyNSw1OS44MjVoMS41MzdoMTQuODgxaDEuNTM3CiAgICAgICAgbDE2LjI5Ny00NC40NjljMC01LjEwNiwwLTEwLjIyNiwwLTE1LjM1NkgyMjguNjk2eiIvPgogICAgPGNpcmNsZSBzdHlsZT0iZmlsbDojODM3M2RiOyIgY3g9IjI1NC4yNzUiIGN5PSI5LjE4IiByPSI5LjE4Ii8+CiAgICA8cGF0aCBzdHlsZT0iZmlsbDojODM3M2RiOyIgZD0iTTE4NC42NzIsNDkuNTI3aC0yOC43NDFWNjMuM2gxMy40OTZsMC4wOTYtMC4wNTVjLTMuMTQ1LDQuODU1LTguNiw4LjA3NS0xNC44MTUsOC4wNzUKICAgICAgICBjLTkuNzQ5LDAtMTcuNjUzLTcuOTAzLTE3LjY1My0xNy42NTNzNy45MDMtMTcuNjUzLDE3LjY1My0xNy42NTNjNC44NzUsMCw5LjI4OCwxLjk3NiwxMi40ODMsNS4xNzFsOS44NjktOS44NjkKICAgICAgICBjLTUuNzItNS43Mi0xMy42MjMtOS4yNTgtMjIuMzUxLTkuMjU4Yy0xNy40NTcsMC0zMS42MDksMTQuMTUyLTMxLjYwOSwzMS42MDljMCwxNy40NTcsMTQuMTUyLDMxLjYwOSwzMS42MDksMzEuNjA5CiAgICAgICAgYzE3LjQ1NywwLDMxLjYwOS0xNC4xNTIsMzEuNjA5LTMxLjYwOWMwLDAsMCwwLDAsMGwwLDBMMTg0LjY3Miw0OS41Mjd6Ii8+CiAgICA8cGF0aCBzdHlsZT0iZmlsbDojODM3M2RiOyIgZD0iTTI0Ni43NSwyMy43ODljMCwyMC4xMjIsMCwzOS45ODEsMCw1OS44MjVjMC4wMTcsMCwwLjAzNCwwLDAuMDUxLDBjMC0xOS45NzYsMC0zOS43OTgsMC01OS44MjUKICAgICAgICBDMjQ2Ljc4NCwyMy43ODksMjQ2Ljc2NywyMy43ODksMjQ2Ljc1LDIzLjc4OXoiLz4KPC9nPgo8L3N2Zz4K', 1190, 10, 200, 50)
                        .add();
                },
            },
        },
    },
};
var exportingConfig = function (exportingDataOverride) {
    if (exportingDataOverride === void 0) { exportingDataOverride = {}; }
    return (__assign(__assign(__assign({}, exports.baseExportingConfig), exportingDataOverride), { filename: exportingDataOverride.filename || exports.baseExportingConfig.filename }));
};
exports.exportingConfig = exportingConfig;
exports.brightTurquoise = ['#59efd1', '#10d4b6', '#089986', '#0b7a6c', '#115049'], exports.casablanca = ['#f3b153', '#ee9121', '#b95c15', '#773c17'], exports.portGore = ['#919fe8', '#5b5cd0', '#3f3f94', '#212244'], exports.geraldine = ['#f57474', '#eb4848', '#b52020', '#7d1f1f'], exports.havelockBlue = ['#a4c7ec', '#5d8ed8', '#4671ca', '#364f97', '#304478'], exports.lavenderRose = ['#f67cd9', '#cf2aa4', '#ac1f84', '#731c58'], exports.emerald = ['#4bc36f', '#2a8f48', '#215a33', '#1d4a2c'], exports.cranberry = ['#ee78ab', '#d23069', '#b62050', '#7e1d3b'];
exports.lineChartColors = [
    exports.brightTurquoise[0],
    exports.casablanca[0],
    exports.portGore[0],
    exports.geraldine[0],
    exports.havelockBlue[0],
    exports.lavenderRose[0],
    exports.emerald[0],
    exports.cranberry[0],
    exports.brightTurquoise[1],
    exports.casablanca[1],
    exports.portGore[1],
    exports.geraldine[1],
    exports.havelockBlue[1],
    exports.lavenderRose[1],
    exports.emerald[1],
    exports.cranberry[1],
    exports.brightTurquoise[2],
    exports.casablanca[2],
    exports.portGore[2],
    exports.geraldine[2],
    exports.havelockBlue[2],
    exports.lavenderRose[2],
    exports.emerald[2],
    exports.cranberry[2],
    exports.brightTurquoise[3],
    exports.casablanca[3],
    exports.portGore[3],
    exports.geraldine[3],
    exports.havelockBlue[3],
    exports.lavenderRose[3],
    exports.emerald[3],
    exports.cranberry[3],
    exports.brightTurquoise[4],
    exports.havelockBlue[4],
];
exports.stackedChartColors = [
    /*'#10d4b6',
    '#363972',
    '#5D8ED8',
    '#8373DB',
    '#F3B153',
    '#b2b6ff',
    '#2cf6fd',
    '#455063',
    '#212244',*/
    exports.brightTurquoise[0],
    exports.casablanca[0],
    exports.portGore[0],
    exports.geraldine[0],
    exports.havelockBlue[0],
    exports.lavenderRose[0],
    exports.emerald[0],
    exports.cranberry[0],
    exports.brightTurquoise[1],
    exports.casablanca[1],
    exports.portGore[1],
    exports.geraldine[1],
    exports.havelockBlue[1],
    exports.lavenderRose[1],
    exports.emerald[1],
    exports.cranberry[1],
    exports.brightTurquoise[2],
    exports.casablanca[2],
    exports.portGore[2],
    exports.geraldine[2],
    exports.havelockBlue[2],
    exports.lavenderRose[2],
    exports.emerald[2],
    exports.cranberry[2],
    exports.brightTurquoise[3],
    exports.casablanca[3],
    exports.portGore[3],
    exports.geraldine[3],
    exports.havelockBlue[3],
    exports.lavenderRose[3],
    exports.emerald[3],
    exports.cranberry[3],
    exports.brightTurquoise[4],
    exports.havelockBlue[4],
];
